import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TrackingService } from 'src/app/services/tracking.service';
import { Constant } from 'src/app/constants/constant';
declare var google:any;

@Component({
  selector: 'calsoft-track-shipment',
  templateUrl: './track-shipment.component.html',
  styleUrls: ['./track-shipment.component.scss']
})
export class TrackShipmentComponent implements OnInit {
  data: any;
  salesFlatShipment: any=[];
  trackValues: any;
  type: void;
  @ViewChild('mapElement') mapNativeElement!: ElementRef;
  directionsService: any;
  directionsDisplay: any;
  map: any;
  latitude: number;
  longitude: number;
  apikey: string;
  duration: any;
  distance: any;
  displayMap:boolean;

  constructor(private dialogRef: MatDialogRef<TrackShipmentComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialog: MatDialog, public trackingService: TrackingService) { 
    this.data = data;
    this.apikey = 'AIzaSyB2dovGx2YDfHA8AKmPsOSp4UAx158pEDs';
  }

 
  ngOnInit(): void {
    this.salesFlatShipment = this.data.page;
    this.trackValues = this.data.track;
    this.type = this.data.types;
    this.displayMap = false;
  }


  close() {
    this.dialog.closeAll()
  }

  //tracking

  ngAfterViewInit(){


    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key='+this.apikey+'&libraries=places';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.directionsService = new google.maps.DirectionsService;
      this.directionsDisplay = new google.maps.DirectionsRenderer;
      this.startWatchPosition();       
    };
    document.body.appendChild(script);
  
  
}

startWatchPosition() {
  let options: any = {
    maximumAge: 0,
    timeout: 5000,
    enableHeightAccuracy: false
  };
  
  let style = [
    {
      featureType: 'all',
      elementType: 'all',
      stylers: [
        { saturation: -100 }
      ]
    }
  ];

  navigator.geolocation.getCurrentPosition((resp) => {

    this.latitude = resp.coords.latitude;
    this.longitude = resp.coords.longitude;

    this.map = new google.maps.Map(document.getElementById('map'), {
      zoom: 7,
      center: {lat: resp.coords.latitude, lng: resp.coords.longitude},
      scaleControl: false,
      streetViewControl: false,
      zoomControl: false,
      overviewMapControl: false,
      mapTypeControl: false,
      mapTypeId: 'SwiggyClone', // Use the identifier as a string, not a constructor
      mapTypeControlOptions: {
       mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'SwiggyClone']
      }
    });

    var mapType = new google.maps.StyledMapType(style, { name: 'Grayscale' });
    this.map.mapTypes.set('SwiggyClone', mapType);
  
    // Set the map to use the custom map type
    this.map.setMapTypeId('SwiggyClone');

   // this.latitude = resp.coords.latitude;
   // this.longitude = resp.coords.longitude;

      this.directionsDisplay.setMap(this.map);        
      this.calculateAndDisplayRoute(this.latitude, this.longitude);

  },(error) => {
    console.log('Error gettinglal location' + JSON.stringify(error));
  },options);
}

  calculateAndDisplayRoute(lat, long){
    const that = this;
    this.directionsService.route({
      //origin: 'trichy',
      //destination: 'madurai',
      origin: new google.maps.LatLng(lat, long),
      destination: new google.maps.LatLng(12.846385349197051, 80.15309602741722),
      travelMode: 'DRIVING'
    }, (response:any, status:any) => {
      if (status === 'OK') {
        //console.log(response)
        that.directionsDisplay.setDirections(response);
      } else {
        window.alert('Directions request failed due to ' + status);
      }
    });
    this.calculateDistanceMatrix(lat, long);
  }

  calculateDistanceMatrix(lat, long) {
    const origin = new google.maps.LatLng(lat, long);
    //const destination = new google.maps.LatLng(12.95671, 80.24829);
   // const origin = new google.maps.LatLng(12.965902392887357, 25068579312686);
    const destination = new google.maps.LatLng(12.846385349197051, 80.15309602741722);
    
    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix({
      origins: [origin],
      destinations: [destination],
      travelMode: 'DRIVING',
    }, (response: any, status: any) => {
      if (status === 'OK' && response.rows.length > 0) {
        this.duration = response.rows[0].elements[0].duration.text;
        this.distance = response.rows[0].elements[0].distance.text;
        const distanceInMeters = response.rows[0].elements[0].distance.value;
        const distanceInKilometers = distanceInMeters / 1000;
        console.log(distanceInKilometers);

      } else {
        console.error('Error fetching Distance Matrix:', status);
      }
    });
  }


}
